import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo obtengo acceso?',
    a: 'Descarga digital inmediata tras el pago. Recibirás un correo con todos los enlaces para acceder a tu Biblia Visual y los bonos.'
  }, {
    q: '¿Hay cargo mensual?',
    a: 'NO. Es un pago único. No hay suscripciones ni cargos ocultos posteriores.'
  }, {
    q: '¿Por qué el precio es tan bajo?',
    a: 'Es una oferta de lanzamiento limitada para ayudar a la mayor cantidad de creyentes posible a tener acceso a este material.'
  }, {
    q: '¿Sirve para principiantes?',
    a: 'Sí. Está diseñado para todos los niveles. Las imágenes y mapas son claros y fáciles de entender, perfectos para quienes recién comienzan a estudiar la Biblia.'
  }, {
    q: '¿Tengo acceso de por vida?',
    a: 'Sí. Tendrás acceso permanente al material y a todas las actualizaciones futuras de forma completamente gratuita.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 bg-cream" data-id="element-89">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90">
        <FadeIn data-id="element-91">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-center text-navy-900 mb-8" data-id="element-92">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-2.5" data-id="element-93">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.06} data-id="element-94">
              <div className={`bg-white rounded-lg border transition-all duration-200 overflow-hidden ${openIndex === index ? 'border-gold shadow-md' : 'border-gray-200 hover:border-gold/50'}`} data-id="element-95">
                <button className="w-full px-5 py-4 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-96">
                  <span className="font-bold text-navy-900 text-base pr-6" data-id="element-97">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-98" />
                </button>

                <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-99">
                  <p className="text-gray-600 leading-relaxed text-sm" data-id="element-100">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}